import { render, staticRenderFns } from "./EightGroup.vue?vue&type=template&id=1fa405eb&scoped=true&"
import script from "./EightGroup.vue?vue&type=script&lang=js&"
export * from "./EightGroup.vue?vue&type=script&lang=js&"
import style0 from "./EightGroup.vue?vue&type=style&index=0&id=1fa405eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa405eb",
  null
  
)

export default component.exports